import { apiClient } from "src/careflow/ph-core/api_client/api_client";

const taskBaseUrl = '/task';

export const createAssessmentTask = async (payload: any): Promise<any> => {
  try {
    const data = await apiClient.post(`${taskBaseUrl}/assessment`, payload);
    return data;
  } catch (error) {
    return {
      create: false,
      status: error.response?.status,
      data: error.response?.data?.response,
    };
  }
};
